










import { Component, Prop, Watch, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { UserMailHistoryTable } from '@/components/organisms/UserMailHistoryTable'
import { MailHistory } from '@/api'
import { UserDetailStateInfo } from '@/types'

export interface UserContentMailHistoryItem {
  mailHistories: MailHistory[]
}

export const defaultUserContentMailHistoryItem = (): UserContentMailHistoryItem => ({
  mailHistories: []
})

@Component({
  components: {
    UserMailHistoryTable
  }
})
export default class UserContentMailHistory extends ComponentVue {
  @Ref()
  userMailHistoryTable!: UserMailHistoryTable

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Object,
    required: true
  })
  item!: UserContentMailHistoryItem

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Watch('state.state')
  onChangeState(): void {
    this.userMailHistoryTable.onSort({
      name: '',
      order: ''
    })
  }
}
